<template>
  <div id="table-wrap">
    <el-table
      :ref="refName"
      :show-header="showHeader"
      :data="tableData"
      :header-cell-style="tableHeaderColor"
      :style="tableWidth"
      :height="tableHeight"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-form label-position="left" inline class="demo-table-expand">
            <template v-for="item in tableProps">
              <el-form-item
                :key="item.prop"
                :label="item.label"
                v-if="item.prop !== 'handle'"
              >
                <span
                  v-if="
                    ['updated_at', 'created_at', 'updatedAt'].includes(
                      item.prop
                    )
                  "
                  >{{ scope.row[item.prop] | filterDate }}</span
                >
                <span v-else>{{ scope.row[item.prop] || "-" }}</span>
              </el-form-item>
            </template>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column
        type="selection"
        align="center"
        v-if="selectCtrl"
        width="50"
      >
      </el-table-column>

      <!-- <el-table-column
        type="index"
        align="center"
        :label="labelNo"
        fixed="left"
        v-if="orderCtrl"
        :key="Math.random()"
        width="50"
      >
        <template slot-scope="scope">
          <span v-if="!!pageSize">{{
            (currentPage - 1) * pageSize + scope.$index + 1
          }}</span>
          <span v-else>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        v-for="{ prop, label, width, btn, obj } in tableProps"
        align="center"
        show-overflow-tooltip
        :prop="prop"
        :key="prop"
        :label="label"
        :fixed="
          prop === 'handle' ||
          prop === 'giftHandle' ||
          prop === 'giftDetailsHandle'
            ? 'right'
            : false || prop === 'cardDetailsHandle'
            ? 'right'
            : false
        "
        :width="width"
      >
        <template slot-scope="scope">
          <div v-if="obj" class="omitText">
            <span v-if="prop === 'useinfo.lastTime'">{{
              scope.row | filterObj(prop) | filterDate
            }}</span>
            <span v-else-if="prop === 'useinfo.enable'">{{
              scope.row | filterObj(prop) ? "是" : "否"
            }}</span>
            <span v-else>{{ scope.row | filterObj(prop) }}</span>
          </div>

          <div
            class="omitText"
            v-else-if="
              prop === 'updated_at' ||
                prop === 'created_at' ||
                prop === 'updatedAt' ||
                prop === 'publishAt' ||
                prop === 'endAt' ||
                prop === 'pay_time' ||
                prop === 'liveAt'
            "
          >
            <span>{{ scope.row[prop] | filterDate }}</span>
          </div>

          <div v-else-if="prop === 'handle'">
            <span v-for="item in btn" :key="item">
              <!-- <span v-if="item === 'swithBtn'">12312 </span> -->
              <el-switch
                v-if="item === 'swithBtn'"
                v-model="scope.row['status']"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                @change="switchChange(scope)"
              >
              </el-switch>
              <span
                v-else
                :class="btnStyle(item)"
                @click="tableHandle(item, scope)"
                >{{ item }}</span
              >
            </span>
          </div>

          <span v-else class="omitText">{{
            scope.row[prop] && scope.row[prop] !== null ? scope.row[prop] : "-"
          }}</span>
        </template>
      </el-table-column>
    </el-table>
    <transition name="fade">
      <DelPopup @deleteHandle="deleteHandle" v-if="delPopup" />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ResizeMixin from "@/mixins/resize";
import DelPopup from "@/components/delPopup";

export default {
  components: {
    DelPopup
  },
  computed: {
    ...mapGetters(["hasData", "delPopup", "userInfo"]),
    labelNo() {
      return this.$t("commonMsg.No");
    }
  },
  mixins: [ResizeMixin],
  props: {
    refName: {
      type: String,
      default: "appTable"
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    tableWidth: {
      type: String,
      default: "width:100%"
    },
    tableData: {
      type: Array,
      default: () => []
    },
    tableProps: {
      type: Array
    },
    selectCtrl: {
      type: Boolean,
      default: false
    },
    orderCtrl: {
      type: Boolean,
      default: true
    },
    currentPage: {
      type: Number,
      default: 1
    },
    expand: {
      type: Boolean,
      default: false
    },
    pageSize: Number
  },

  data() {
    return {
      selectDataIds: [],
      selectData: [],
      scopeItem: null
    };
  },

  filters: {
    filterObj(obj, value) {
      let temp = value.split(".");
      if (temp.length === 2 && obj[temp[0]]) {
        return obj[temp[0]][temp[1]];
      } else if (temp.length === 3 && obj[temp[0]] && obj[temp[0]][temp[1]]) {
        return obj[temp[0]][temp[1]][temp[2]];
      }
    }
  },

  methods: {
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f7f7f7;font-weight: 500;";
      }
    },

    btnStyle(item) {
      let className;
      switch (item) {
        case this.$t("commonMsg.checkDetails"):
        case this.$t("commonMsg.edit"):
          className = "checkDetailsBtn";
          break;
        case this.$t("commonMsg.del"):
        case this.$t("commonMsg.remove"):
        case this.$t("commonMsg.destroy"):
        case this.$t("commonMsg.correction"):
        case this.$t("sale.gift.handle"):
        case "Token失效":
        case "笔记PDF修正":
        case "OSS查询":
        case "CB查询":
          className = "delBtn";

          break;

        default:
          break;
      }
      return className;
    },

    // 表格上下移动排序
    tableSort(type, scope) {
      this.emitEvn(type, scope, "tableSort");
    },

    switchChange(scope) {
      this.emitEvn(null, scope, "switchChange");
    },

    giftHandle(type, scope) {
      if (type === "commonMsg.del") {
        this.scopeItem = scope;
        this.$store.commit("windowHandle", "delPopup");
      } else {
        this.emitEvn(this.$t(type), scope, "tableHandle");
      }
    },

    // 表格操作按钮
    tableHandle(type, scope) {
      if (type === this.$t("commonMsg.del")) {
        this.scopeItem = scope;
        this.$store.commit("windowHandle", "delPopup");
      } else {
        this.emitEvn(type, scope, "tableHandle");
      }
    },

    //  确认删除
    deleteHandle() {
      this.emitEvn(this.$t("commonMsg.del"), this.scopeItem, "tableHandle");
    },

    emitEvn(type, scope, evn) {
      let obj = {
        type: type || "",
        data: scope
      };
      this.$emit(evn, obj);
    },

    handleSelectionChange(data) {
      this.$emit("tableSelection", data);
    }
  }
};
</script>

<style lang="scss">
#table-wrap {
  height: 100%;
  .demo-table-expand {
    label {
      width: 90px;
    }
    .el-form-item {
      margin-right: 0;
      margin-bottom: 0;
      width: 50%;
    }
  }

  .appTable-move {
    > i {
      display: inline-block;
      width: 22px;
      height: 22px;
      cursor: pointer;
      font-size: 20px;
      margin: 0 5px;
      font-weight: bold;
      vertical-align: middle;
    }
    .move-up {
      background: url("~@/assets/img/cmb_move_up.png") no-repeat;
    }
    .move-down {
      background: url("~@/assets/img/cmb_move-down.png") no-repeat;
    }
  }
  .green {
    color: green;
  }
}
</style>
